import { render, staticRenderFns } from "./ParentEdit.vue?vue&type=template&id=dbc34404"
import script from "../../controllers/parent/parent-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/parent/parent-edit.js?vue&type=script&lang=js&external"
import style0 from "./ParentEdit.vue?vue&type=style&index=0&id=dbc34404&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports